var arrowUrl = 'img-chervon-icon.svg';

$('.header__bottom--wrapper').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 7000,
  prevArrow:
    '<button type="button" class="slick-prev"><img src="//www.as3performance.com/cdn/shop/t/78/assets/img-chevron-icon.svg?v=90816361318345084961789323474" /><span class="sr-only">Previous</span></button>',
  nextArrow:
    '<button type="button" class="slick-next"><img src="//www.as3performance.com/cdn/shop/t/78/assets/img-chevron-icon.svg?v=90816361318345084961789323474" /><span class="sr-only">Next</span></button>'
  // responsive: [
  //   {
  //     breakpoint: 1200,
  //     settings: {
  //       slidesToShow: 2,
  //       slidesToScroll: 2
  //     }
  //   },
  //   {
  //     breakpoint: 768,
  //     settings: {
  //       slidesToShow: 1,
  //       slidesToScroll: 1
  //     }
  //   }
  // ]
});

$('.productheader__image--main').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  draggable: false,
  asNavFor: '.productheader__image--nav',
  swipe: false
});

$('.productheader__image--nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  focusOnSelect: true,
  asNavFor: '.productheader__image--main'
});
